module.exports = __webpack_public_path__ + "static/media/ic_girl.773f4bec.svg";